<template>
  <div>
    <v-btn-toggle
      :value="isRecurrent"
      mandatory
      class="mr-2"
      @change="$emit('update:isRecurrent', $event)"
    >
      <v-btn :disabled="disableRecurrenceEdit" small :value="false">
        Does Not Repeat
      </v-btn>
      <v-btn :disabled="disableRecurrenceEdit" small :value="true">
        Repeats
      </v-btn>
    </v-btn-toggle>
    <AppTooltip v-if="disableRecurrenceEdit" text="Once a task is created, its recurrence settings cannot be changed. To use different recurrence settings, please create a new task." />
    <template v-if="isRecurrent">
      <div v-if="rruleEntry && !isEdit" class="mt-4 d-flex align-center">
        Repeats: {{ scheduleText }} <v-btn
          icon
          x-small
          data-track="task.schedule.edit"
          @click="isEdit = true"
        >
          <v-icon small>mdi-pencil</v-icon>
        </v-btn>
      </div>
      <ScheduleForm
        v-else
        ref="scheduleForm"
        hide-title
        end-date-required
        :rrule-entry="rruleEntry"
        :min-start-date="minStartDate"
        @submit="submitHandler"
      />
    </template>
  </div>
</template>

<script lang="ts">
import Vue from 'vue'
import { DateTime } from 'luxon';
import { RRule } from 'rrule';

import { Nullable } from '@/utils/types';
import { getRRuleScheduleText } from '@/bundles/MarketingTemplate/helpers';

import ScheduleForm from '@/bundles/MarketingTemplate/components/forms/ScheduleForm.vue';
import AppTooltip from '@/bundles/App/components/common/AppTooltip.vue';

export default Vue.extend({
  name: 'TaskSchedule',

  components: { AppTooltip, ScheduleForm },

  props: {
    isRecurrent: Boolean,
    rruleEntry: {
      type: String,
      default: null
    },
    disableRecurrenceEdit: Boolean,
  },

  data: (): { isEdit: boolean } => ({
    isEdit: false,
  }),

  computed: {
    scheduleText (): Nullable<string> {
      if (!this.rruleEntry) {
        return null;
      }

      return getRRuleScheduleText(this.rruleEntry);
    },
    minStartDate (): string {
      return DateTime.now().toISODate();
    },
  },

  watch: {
    isRecurrent (newVal: boolean) {
      if (!newVal) {
        this.$emit('submit', { rrule: null });
        this.isEdit = false;
      }
    }
  },

  methods: {
    submitHandler (payload: { rrule: RRule; dateEnd: string; time: string; }) {
      this.$emit('submit', payload);
      this.isEdit = false;
    },
    flushPendingSchedule (): boolean {
      if (!this.$refs.scheduleForm) {
        return true;
      }

      return (this.$refs.scheduleForm as InstanceType<typeof ScheduleForm>).submitHandler();
    }
  }
})
</script>
